import React, { useState } from 'react';
import useVatavData from '../../../hooks/useVatavData';

export default function VatavAccountsPanel() {
  const { accounts, loading, err, msg, createAccount, loadAll } = useVatavData();
  const [name, setName] = useState('');
  const [mobileNo, setMobileNo] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await createAccount({ name, mobileNo });
      setName('');
      setMobileNo('');
    } catch {
      /* err in hook */
    }
  };

  return (
    <div style={{ padding: '0 8px' }}>
      <p style={{ fontSize: 14, color: '#444', marginTop: 0 }}>
        Create and manage Vatav accounts used for transfers.
      </p>
      {err && <p style={{ color: 'crimson', marginBottom: 8 }}>{err}</p>}
      {msg && <p style={{ color: 'green', marginBottom: 8 }}>{msg}</p>}

      <h3 style={{ marginTop: 0 }}>New account</h3>
      <form onSubmit={onSubmit} style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 24 }}>
        <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
        <input placeholder="Mobile no." value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} />
        <button type="submit">Save account</button>
        <button type="button" onClick={loadAll} disabled={loading}>
          Refresh
        </button>
      </form>

      <h3>Vatav ledger (accounts)</h3>
      {loading ? (
        <p>Loading…</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table border="1" cellPadding={6} style={{ borderCollapse: 'collapse', width: '100%', fontSize: 13, background: '#fff' }}>
            <thead style={{ background: '#eee' }}>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {accounts.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: 'center' }}>
                    No accounts yet.
                  </td>
                </tr>
              )}
              {accounts.map((a) => (
                <tr key={a._id}>
                  <td>{a.name}</td>
                  <td>{a.mobileNo || '—'}</td>
                  <td>{a.createdAt ? new Date(a.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
